import { useEffect } from "react";
import type { EnvironmentId } from "@cmmd-forge/contracts";

import { refreshGitStatus } from "~/lib/gitStatusState";

const GIT_STATUS_WINDOW_REFRESH_DEBOUNCE_MS = 250;

export function useGitStatusWindowRefresh(input: {
  readonly activeEnvironmentId: EnvironmentId | null;
  readonly gitCwd: string | null;
}): void {
  useEffect(() => {
    if (input.gitCwd === null) return;

    let refreshTimeout: number | null = null;
    const scheduleRefreshCurrentGitStatus = () => {
      if (refreshTimeout !== null) {
        window.clearTimeout(refreshTimeout);
      }
      refreshTimeout = window.setTimeout(() => {
        refreshTimeout = null;
        void refreshGitStatus({
          environmentId: input.activeEnvironmentId,
          cwd: input.gitCwd,
        }).catch(() => undefined);
      }, GIT_STATUS_WINDOW_REFRESH_DEBOUNCE_MS);
    };
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        scheduleRefreshCurrentGitStatus();
      }
    };

    window.addEventListener("focus", scheduleRefreshCurrentGitStatus);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      if (refreshTimeout !== null) {
        window.clearTimeout(refreshTimeout);
      }
      window.removeEventListener("focus", scheduleRefreshCurrentGitStatus);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [input.activeEnvironmentId, input.gitCwd]);
}
